import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import Relay from 'react-relay';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {sendToExtension, onClickExtensionInstall, getExtensionURL} from '../app/ExtensionCommunicate';
import * as Permission from './../../common/util/Permission';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import {sendError} from '../app/errorDisplayer';

import Link from 'react-router/lib/Link';
import * as BrowserPermission from '../BrowserPermission';

class HomePage extends React.Component {

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            missingExtension: true,
			showEmptyContent: false,
        };
    }

    componentWillMount() {
        if (getLastOrganisationId()) {
            let lastOrganisationId = getLastOrganisationId();

            let path = urlMapping.getUrl(types['organisations'], "view", {id: lastOrganisationId});
            this.context.router.replace(path);
        }
		else if (this.props.user.organisations && this.props.user.organisations.edges && this.props.user.organisations.edges.length > 0 && this.props.user.organisations.edges[0].node.realId) {
			let path = urlMapping.getUrl(types['organisations'], "view", {id: this.props.user.organisations.edges[0].node.realId});
            this.context.router.replace(path);
		}
		else {
            sendToExtension({
                message: 'dativery-version'
            }).then((response) => {
                if (response) {
                    this.setState({
                        'missingExtension': false
                    });
                }
            }).catch((e) => {
                sendError(e);
            });

			let self = this;
			setTimeout(() => {
				self.setState({
					showEmptyContent: true
				});
			}, 0);
        }
    }

    render() {
		if (!this.state.showEmptyContent) {
			return null;
		}

        return (
            <AppPanel title="Title">
                <div className="home-page">

                    <h2><FormattedMessage defaultMessage="Installation guide" id="home.title" /></h2>
                    <ol>
                        {this.state.missingExtension ? <li><a href={getExtensionURL()} onClick={onClickExtensionInstall} target="_blank"><FormattedMessage defaultMessage="Install browser extension" id="home.installExtension" /></a></li> : null}
                        {BrowserPermission.hasPermission(Permission.PERM_ADD_ORGANISATION) ?
                            <li><Link to="/organisations/add/"><FormattedMessage defaultMessage="Create your own organisation or" id="home.createOrganisation"/></Link></li>
                            : null}
                            <li><FormattedMessage defaultMessage="Accept an invitation send to you by your collegue over an e-mail." id="home.acceptInvitation" /></li>


                    </ol>
                </div>
            </AppPanel>
        );
    }

}

export default Relay.createContainer(HomePage, {
    fragments: {
        user: () => Relay.QL`
        fragment on User {
            id,
			email,
			firstname,
			surname,
            organisations(first: 1) {
                edges {
                    node {
                        id,
                        realId,
                    }
                }
            }
        }
    `,
    },
});
